<template>
  <div class="flex flex-col gap-6 z-1000 w-full h-full">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
        <template #action>
          <div
            v-if="$route.name !== 'role_item_view'"
            class="flex items-center gap-2"
          >
            <el-tooltip
              v-if="uuid && uuid !== 'new'"
              :content="$t('Режим просмотра')"
              placement="top"
            >
              <Button variant="outline" size="icon" @click="goToView">
                <svg-icon name="huge-eye" class="w-4 h-4 text-foreground" />
              </Button>
            </el-tooltip>
            <Button variant="default" :disabled="loader" @click="submitForm">{{
              $t("Сохранить")
            }}</Button>
          </div>
          <div v-else class="flex items-center gap-3">
            <!-- <Button variant="outline" size="icon">
              <svg-icon name="huge-print" class="w-4 h-4 text-foreground" />
            </Button>
            <Button variant="outline" size="icon">
              <svg-icon name="huge-download" class="w-4 h-4 text-foreground" />
            </Button> -->
            <Button variant="outline" size="icon" @click="goToEdit">
              <svg-icon name="huge-edit" class="w-4 h-4 text-foreground" />
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger as-child>
                <Button variant="default">
                  {{ $t("Операции") }}
                  <svg-icon name="huge-down" class="w-5 h-5 ml-2 text-white" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" class="w-[282px]">
                <template v-for="(item, index) in actions" :key="item.label">
                  <DropdownMenuSeparator v-if="item.isLast" />
                  <DropdownMenuItem
                    :variant="
                      item.type === 'danger' ? 'destructive' : undefined
                    "
                    @click="
                      handleActions({
                        action: item.action,
                        uuid: uuid,
                        rowData: form,
                      })
                    "
                  >
                    <svg-icon
                      v-if="item.icon"
                      :name="item.icon"
                      class="w-5 h-5"
                      :class="item.type ? item.type : ''"
                    />
                    <span :class="item.type ? item.type : ''">
                      {{ $t(item.label) }}
                    </span>
                  </DropdownMenuItem>
                </template>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </template>
      </BaseTabs>
    </div>

    <component
      :is="currentTabComponent"
      :form="form"
      :selected-role="selected_role"
      ref="activeForm"
      class="flex-1 w-full h-full"
    />
  </div>
</template>

<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import Button from "@/shared/ui/button/Button.vue";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import DataRole from "./tabs/DataRole.vue";
import RoleHistory from "./tabs/RoleHistory.vue";
import RoleSettingRight from "./tabs/RoleSettingRight.vue";
import { getRoleItem, updateRole, createRole } from "@/entities/role";

export default {
  name: "RoleItem",
  components: {
    LoadingOverlay,
    BaseTabs,
    Button,
    DataRole,
    RoleHistory,
    RoleSettingRight,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  },
  data() {
    return {
      loading: false,
      loader: false,
      activeTab: "data",
      selected_role: null,

      form: {
        name: "",
        name_kz: "",
        code: "",
        permissions: [],
      },
    };
  },
  async created() {
    if (this.uuid && this.uuid !== "new") {
      await this.getRoleItem();
    }
  },
  computed: {
    tabs() {
      const tabs = {
        data: {
          label: this.$t("Параметры роли"),
          icon: "huge-text-config",
        },
        setting_right: {
          label:
            this.$route.name === "role_item_view"
              ? this.$t("Назначенные права")
              : this.$t("Настройка прав"),
          icon: "huge-unlock",
        },
      };

      if (this.$route.name === "role_item_view") {
        tabs.history = {
          label: this.$t("История"),
          icon: "huge-history",
        };
      }

      return tabs;
    },

    uuid() {
      return this.$route.params.id;
    },

    currentTabComponent() {
      const tabComponents = {
        data: DataRole,
        setting_right: RoleSettingRight,
        history: RoleHistory,
      };

      return tabComponents[this.activeTab] || null;
    },

    actions() {
      return [
        {
          label: "Завершить сессию",
          type: "danger",
          action: "block",
          icon: "huge-close",
        },
      ];
    },
  },
  watch: {
    "$route.name"() {
      if (this.uuid && this.uuid !== "new") {
        this.getRoleItem();
      }
      if (!this.tabs[this.activeTab]) {
        const fallbackTab = Object.keys(this.tabs)[0];
        this.activeTab = fallbackTab;
        this.changeTab(fallbackTab);
      }
    },
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab) {
          this.activeTab = tab;
        }
      },
    },
  },

  methods: {
    async getRoleItem() {
      this.loading = true;

      try {
        let data = await getRoleItem(this.uuid);
        if (data?.success) {
          if (data?.payload) {
            this.selected_role = data.payload;
          }

          this.form = {
            name: this.selected_role.name,
            name_kz: this.selected_role.name_kz,
            code: this.selected_role.code,
            permissions: this.selected_role?.permissions || [],
          };
        }
      } finally {
        setTimeout(() => (this.loading = false), 500);
      }
    },
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
    goToView() {
      this.$router.push({
        name: "role_item_view",
        params: { id: this.uuid },
      });
    },
    goToEdit() {
      this.$router.push({
        name: "role_item",
        params: { id: this.uuid },
      });
    },
    handleActions() {},
    async submitForm() {
      const form = this.$refs.activeForm;
      if (form && form.validate) {
        const valid = await form.validate();
        if (valid) {
          if (this.uuid && this.uuid !== "new") {
            await this.updateRole();
          } else {
            await this.createRole();
          }
        } else {
          console.warn("❌ Validation failed");
        }
      }
    },
    async createRole() {
      this.loader = true;
      try {
        let data = await createRole(this.form);
        if (data.success && data.payload?.code) {
          this.$router.push({
            name: "role_item_view",
            params: { id: data.payload?.code },
          });
        }
      } finally {
        this.loader = false;
      }
    },
    async updateRole() {
      this.loader = true;
      try {
        let data = await updateRole(this.uuid, this.form);
        if (data.success) {
          this.$router.push({
            name: "role_item_view",
            params: { id: this.uuid },
          });
        }
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  @apply h-10 flex justify-center items-center p-4 bg-card border;
  @apply border-border rounded outline-none;
  &:active {
    transform: scale(0.98);
  }
}

.danger {
  @apply text-red-400;
}
</style>
